import script from "./CreateOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOrder.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__